import axios from "axios";

const isDebug = process.env.REACT_APP_ENV === "DEBUG";
const isLocal = process.env.REACT_APP_ENV === "LOCAL";

const BASE_API_URL = isLocal
  ? "http://localhost:8080/api/open-ai"
  : isDebug
  ? "https://dev.fortune.leinotek.com/api/open-ai"
  : "https://fortune.leinotek.com/api/open-ai";

class OpenAIService {
  enableChartService(year, month, day, hour, minute, gender) {
    return axios.post(BASE_API_URL + "/enchart-service", {
      year,
      month,
      day,
      hour,
      minute,
      gender,
    });
  }

  getUserChart(userBirthID) {
    return axios.post(BASE_API_URL + "/get-user-chart", {
      userBirthID,
    });
  }
}

const openAIService = new OpenAIService();
export default openAIService;
